/* ==========================================================================
   SearcherFlight > Client > Submit > Loader
   ========================================================================== */

/* Modules */
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');
const { addData, addStyle } = require('@bluekiri/alexandria/helpers/dataHelpers');

const Loader = require('@bluekiri/alexandria-contrib-components/components/loading-information-rxjs/client/js');
const LoaderTemplate = require('@bluekiri/alexandria-contrib-components/components/loading-information-rxjs/template');

const configuration = require('../../config');
const { OPENJAW } = require('../../product/constants');

function buildDescription(instance) {
    const { product } = instance.store.select('data');
    const { origin, destination, calendar, passengers, classes, discount, rows } = instance;
    if (product !== OPENJAW) {
        return `
            ${origin.hooks.input.value} - ${destination.hooks.input.value}, 
            ${calendar.hooks.input.value}, 
            ${passengers.hooks.input.value}, 
            ${classes ? `${classes.hooks.select.textContent}` : ''}
            ${discount ? `, ${discount.hooks.input.value}` : ''}
        `;
    }

    return `
        ${rows
            .map(
                item =>
                    `${item.origin.hooks.input.value} - ${item.destination.hooks.input.value} - 
                    ${item.calendar.hooks.input.value}, <br />`
            )
            .join('')},
        ${passengers.hooks.input.value}, 
        ${classes ? `${classes.hooks.select.textContent}` : ''}
        ${discount ? `, ${discount.hooks.input.value}` : ''}
    `;
}

/* Create */
function createLoader(instance) {
    /* Data */
    const { context, literals } = instance.config;
    const { titleLoaderLabel = 'Buscando vuelos', messageLoaderLabel = 'Espera, por favor...' } = literals;

    /* Build description */
    const description = buildDescription(instance);

    /* Template */
    const template = LoaderTemplate(
        addStyle(
            addData(
                {
                    image: {
                        src: instance.config.loader
                    },
                    title: titleLoaderLabel,
                    description,
                    message: messageLoaderLabel
                },
                {
                    type: configuration().type.loading
                }
            ),
            [configuration().css.flight]
        ),
        context
    );

    /* Node */
    const node = toNode(template)[0];

    /* Return */
    return node;
}

/* Add */
function addLoader(instance) {
    const panel = instance;

    /* Node */
    const node = createLoader(instance);

    /* Add to DOM */
    document.body.appendChild(node);

    /* Reference */
    panel.loader = Loader(`[data-component=LoadingInformationRxjs][data-type=${configuration().type.loading}]`);
}

/* Exports */
module.exports = {
    addLoader
};
